const clientPublicKey = `-----BEGIN PUBLIC KEY-----
MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgHZhY4oE2WcDSDJpPApP8uuQTODN
jJBCrnSo7YF0PyfbnNg16TBX3ZqnLV1LREU2aWmUpqvYMEypvTzfoBNFhBv2u/Rx
IXLVSptPNybA+ux/p7Ce0/nbzzvyL0phNAfBugUJppLbVgiDIk2HbyvUwXtNOta9
is2/w3Mp7TSpZF/fAgMBAAE=
-----END PUBLIC KEY-----`


const uriClientPublicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCGXy48HaRWHP5r3ECeUSsI6s6B
sfvNtMV2ipp+MPZzqpOltNF2ZyHLjyCJU2Vxt60lnpRYZNAaLpj6wDgWmEtcdatD
NVVkJUHmjNvR6+xHFPA6TQPSyxc+XlBy5Dzm8NcPPv6lWU6Ehf4yg2+eifMXThUd
E0VLJXJsGi75uasKWwIDAQAB
-----END PUBLIC KEY-----`



const serverPrivateKey = ``


export default {
    CLIENT_PUBLIC_KEY: clientPublicKey,
    SERVER_PRIVATE_KEY: serverPrivateKey,
    URI_CLIENT_PUBLIC_KEY: uriClientPublicKey
}
